module.exports = __webpack_public_path__ + "img/mp4.6da85a52.svg";